var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrangeDifficulty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.679,
    height: 73.66,
    viewBox: "0 0 90.679 90.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "difficutly-icon",
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11020",
    "data-name": "Group 11020",
    transform: "translate(15.846 14.116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40243",
    "data-name": "Path 40243",
    d: "M0,0H22.011V2.954H0Z",
    transform: "translate(2.9 7.528) rotate(-19.993)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40244",
    "data-name": "Path 40244",
    d: "M0,0H2.954V33.425H0Z",
    transform: "translate(33.372 4.705) rotate(-45)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40245",
    "data-name": "Path 40245",
    d: "M0,0H2.953V17.894H0Z",
    transform: "matrix(0.136, -0.991, 0.991, 0.136, 37.176, 29.722)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40246",
    "data-name": "Path 40246",
    d: "M0,0H2.954V26.426H0Z",
    transform: "translate(1.251 14.59) rotate(-63.435)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40247",
    "data-name": "Path 40247",
    d: "M0,0H2.956V23.662H0Z",
    transform: "matrix(0.448, -0.894, 0.894, 0.448, 2.242, 53.506)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40248",
    "data-name": "Path 40248",
    d: "M31,33h2.954V58.113H31Z",
    transform: "translate(-2.484 0.201)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40249",
    "data-name": "Path 40249",
    d: "M0,0H45.756V2.954H0Z",
    transform: "matrix(0.544, -0.839, 0.839, 0.544, 0.055, 42.727)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40250",
    "data-name": "Path 40250",
    d: "M0,0H33.728V2.954H0Z",
    transform: "matrix(0.691, -0.723, 0.723, 0.691, 33.885, 59.466)",
    fill: "#fb6d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40251",
    "data-name": "Path 40251",
    d: "M0,0H2.954V47.651H0Z",
    transform: "matrix(0.86, -0.511, 0.511, 0.86, 0, 18.108)",
    fill: "#fb6d3d"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_40252",
    "data-name": "Path 40252",
    d: "M23.681,47.341a10.11,10.11,0,0,1-1.093,4.624,10.338,10.338,0,1,1,1.093-4.624Z",
    transform: "translate(0 16.226)",
    fill: "#1c1839",
    stroke: "#fb6d3d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40253",
    "data-name": "Path 40253",
    d: "M43.185,50.619a10.2,10.2,0,0,1,2.5,6.721,10.341,10.341,0,1,1-20.105-3.4,10.327,10.327,0,0,1,17.609-3.324Z",
    transform: "translate(10.499 20.998)",
    fill: "#1c1839",
    stroke: "#fb6d3d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40254",
    "data-name": "Path 40254",
    d: "M57.341,25a10.341,10.341,0,1,1,0,20.681A10.384,10.384,0,0,1,47,35.341a8.66,8.66,0,0,1,.1-1.389A10.318,10.318,0,0,1,57.341,25Z",
    transform: "translate(20.998 10.499)",
    fill: "#1c1839",
    stroke: "#fb6d3d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40255",
    "data-name": "Path 40255",
    d: "M45.578,33.729A10.335,10.335,0,0,1,25,32.341a10.11,10.11,0,0,1,1.093-4.624,10.339,10.339,0,0,1,19.588,4.624A8.659,8.659,0,0,1,45.578,33.729Z",
    transform: "translate(10.499 9.067)",
    fill: "#1c1839",
    stroke: "#fb6d3d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40256",
    "data-name": "Path 40256",
    d: "M35.341,3a10.341,10.341,0,1,1,0,20.681A10.337,10.337,0,0,1,25,13.341,10.333,10.333,0,0,1,35.341,3Z",
    transform: "translate(10.499)",
    fill: "#1c1839",
    stroke: "#fb6d3d",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40257",
    "data-name": "Path 40257",
    d: "M23.061,17.81a10.313,10.313,0,0,1,.62,3.531,10.11,10.11,0,0,1-1.093,4.624,10.338,10.338,0,1,1,.473-8.154Z",
    transform: "translate(0 3.818)",
    fill: "#1c1839",
    stroke: "#fb6d3d",
    strokeWidth: 5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeDifficulty);
export default __webpack_public_path__ + "static/media/orange-difficulty.f4f63243fe4d8ddbe8284e493b58b59d.svg";
export { ForwardRef as ReactComponent };